7<template>
    <div id="container">
        <div class="headerLogin">
            <div>
                <img class="img" src="../../../static/image/login/logo.png" alt="">
                <span class="span">欢迎登录</span>
            </div>
        </div>
        <div class="contant">
            <!-- <img src="../../../static/image/login/蒙版组 15.png" alt=""> -->
            <div id="informationUser">
                <img class="img" src="../../../static/image/login/loginimg.png" alt="">
                <div class="user">
                    <span class="span">用户登录</span>
                    <div>
                        <img src="../../../static/image/login/姓名.png" alt="">
                        <input class="username" type="text" v-model="userName" placeholder="输入手机号">
                        <!-- <br> -->
                        <img src="../../../static/image/login/密码.png" alt="">
                        <input class="password" type="password" v-model="password" placeholder="输入验证码">
                    </div>
                    <div>
                        <span class="register" @click="register">注册账号</span>
                        <span class="forgetPassword" @click="forgetPassword">忘记密码</span>
                    </div>
                    <div>
                        <button @click="login" class="button">登录</button>
                    </div>
                    <div>
                        <span class="code" @click="messageCode">密码登录</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loginNumber',
    data () {
        return {
            userName: '',
            password: ''
        }
    },
    methods: {
        register() {
            this.$router.push({
            name:'register'
          })
            console.log('llll')
        },
        forgetPassword() {
            console.log('oooo')
        },
        login() {
            console.log('login')
        },
        messageCode() {
            this.$router.push({ name: 'login'})
            console.log('messageCode')
        }
    }
}
</script>

<style lang='less' scoped>
.headerLogin{
    width: 100%;
    height: 118px;
    // background: red;
    .img{
        margin-left: 379px;
        margin-top: 24px;
    }
    .span{
        position: relative;
        top: -12px;
        margin-left: 27px;
        width: 104px;
        height: 30px;
        font-size: 25px;
        font-weight: 500;
        color: #333333;
    }
}
#informationUser{
    width: 777px;
    height: 486px;
    background: palegoldenrod;
    margin-top: 126px;
    margin-left: 572px;
    .img{
        margin-top: 6px;
        margin-left: 9px;
         display: inline-block;
    }
    .user{
         display: inline-block;
         float: right;
         margin-top: 100px;
        .span{
            width: 104px;
            height: 36px;
            font-size: 25px;
            line-height: 31px;
            color: #333333;
            opacity: 1;
            display: inline-block;
        }
        .username{
            border: none;
        }
        .username:focus{
            border: none;
            outline: none;
        }
        .password{
            border: none;
        }
        .password:focus{
            border: none;
            outline: none;
        }
        .register{
            cursor: pointer;
            margin-left: 65px;
            width: 54px;
            height: 18px;
            font-size: 13px;
            font-weight: 500;
        }
        .forgetPassword{
            cursor: pointer;
            float: right;
            width: 68px;
            height: 18px;
            font-size: 13px;
            font-weight: 500;
        }
        .button{
            width: 268px;
            height: 40px;
            background: #DFB876;
            margin-top: 24px;
            margin-left: 65px;
            border-radius: 20px;
        }
        .code{
            cursor: pointer;
            margin-left: 160px;
            margin-top: 30px;
            width: 95px;
            height: 18px;
            font-size: 13px;
            font-weight: 500;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/loginNumber.vue